import axios from "./axios";

export const findSignature = async (meetingNumber) => {
  let res = await axios.get(
    `/service/system/GetSignature?meetingNumber=${meetingNumber}`
  );
  return res.data;
};
